import React, { useState } from 'react';
import { CompetitorOffer } from './service';

interface CompetitiveSelectProps {
  offers: CompetitorOffer[];
  defaultSelected: string;
  onSelect: (selectedSpeed: string) => void;
}

const CheckIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 20 20"
    fill="currentColor"
    aria-hidden="true"
    className="w-5 h-5 text-blue-600"
  >
    <path
      fillRule="evenodd"
      d="M16.707 5.293a1 1 0 00-1.414 0L7 13.586 4.707 11.293a1 1 0 00-1.414 1.414l3 3a1 1 0 001.414 0l9-9a1 1 0 000-1.414z"
      clipRule="evenodd"
    />
  </svg>
);

const CompetitiveSelect: React.FC<CompetitiveSelectProps> = ({ offers, defaultSelected, onSelect }) => {
  const [selectedSpeed, setSelectedSpeed] = useState(defaultSelected);
  const [isOpen, setIsOpen] = useState(false);

  const handleSelectChange = (speed: string) => {
    setSelectedSpeed(speed);
    onSelect(speed);
    setIsOpen(false);
  };

  return (
    <div className="relative w-full">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="relative w-full cursor-default rounded-md bg-white py-1 pl-3 pr-10 text-left text-gray-900 sm:text-sm sm:leading-6"
      >
        <span className="block truncate">{selectedSpeed}</span>
        <span className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="size-5">
            <path fillRule="evenodd" d="M12.53 16.28a.75.75 0 0 1-1.06 0l-7.5-7.5a.75.75 0 0 1 1.06-1.06L12 14.69l6.97-6.97a.75.75 0 1 1 1.06 1.06l-7.5 7.5Z" clipRule="evenodd" />
          </svg>
        </span>
      </button>
      {isOpen && (
        <ul className="absolute z-10 mt-1 w-full bg-white border rounded-lg shadow-lg max-h-60 py-1 text-base overflow-auto focus:outline-none sm:text-sm">
          {offers.map((offer, index) => (
            <li
              key={index}
              onClick={() => handleSelectChange(offer.download_speed)}
              className={`cursor-pointer select-none relative py-2 pl-10 pr-4 ${selectedSpeed === offer.download_speed ? 'text-blue-900' : 'text-gray-900'
                } hover:bg-blue-100 hover:text-gray-900`}
            >
              <span className={`block truncate ${selectedSpeed === offer.download_speed ? 'font-medium' : 'font-normal'}`}>
                {offer.download_speed}
              </span>
              {selectedSpeed === offer.download_speed && (
                <span className="absolute inset-y-0 left-0 flex items-center pl-3">
                  <CheckIcon />
                </span>
              )}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default CompetitiveSelect;
